export default __webpack_public_path__ + "static/media/login-logo.409367e0.png";